// prettier-ignore
const template = (data) => `
    <div class="grid__item">
        <article class="card card--pink card--auto-height card--solutions solutions__card">
            <a href="${data.url}" class="card__link solutions__link">
                <figure class="card__icon solutions__icon">
                    <picture class="solutions__image">
                        ${data.image?.src ? `<img src="${data.image?.src}" alt="${data.image?.alt}"  />` : ''}
                    </picture>
                </figure>
                ${data.title ? `<h4 class="card__heading solutions__heading">${data.title}</h4>` : ''}
                <div class="card__cta">
                    <span class="card__cta-icon">
                        <svg width="6" height="14">
                            <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#chevron-right"></use>
                        </svg>
                    </span>
                    <p class="card__cta-text">Discover More</p>
                </div>
            </a>
        </article>
    </div>
`

export default template
